import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { message, Button, Result } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';

export default function Success() {
  const navigate = useNavigate();

  useEffect(() => {
    message.success("Subscription successful!");
  }, []);

  return (
    <Result
      icon={<CheckCircleOutlined style={{ color: 'green' }} />}
      title="Subscription Successful"
      subTitle="Your subscription has been successfully completed."
      extra={
        <Button type="primary" onClick={() => navigate('/leads')}>
          Go to Dashboard
        </Button>
      }
    />
  );
}
